export default __webpack_public_path__ + "static/media/ikon-lonjong.c5c564c9.svg";